import capitalizeFirstLetter from './capitalizeFirstLetter';

export default function makeDisplayProductName(item, includeProductNameInExpression = false) {
  let displayProductName; //IKEA product name, e.g. KASKER

  if (includeProductNameInExpression) {
    displayProductName = `${item.ProductName}`;
  } else {
    displayProductName = false;
  }

  if (displayProductName) {
    return displayProductName.replace(/\//g, ' / ');
  }
}
